import React, { useState, useEffect, useCallback, useRef } from 'react'; 
import { auth, db } from '../OurCourses/firebase';
import { collection, getDocs, deleteDoc, doc, updateDoc, addDoc, query, orderBy, onSnapshot, limit, where, serverTimestamp } from 'firebase/firestore';

import jsPDF from 'jspdf';
import * as XLSX from 'xlsx';
import './adminpanel.css';


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faTrash, faSpinner, faSearch, faFilter } from '@fortawesome/free-solid-svg-icons';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


import Papa from 'papaparse';


import {
  ResponsiveContainer,
  BarChart,
  Bar,
  LineChart,
  Line,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
} from "recharts";





import dayjs from "dayjs";
import isoWeek from "dayjs/plugin/isoWeek";
import weekOfYear from "dayjs/plugin/weekOfYear";

dayjs.extend(isoWeek);
dayjs.extend(weekOfYear);



function AdminPanel() {
  const [activeTab, setActiveTab] = useState('viewAllSubmission'); // Default tab
  const [users, setUsers] = useState([]);




const [chequeNumber, setChequeNumber] = useState("");




  // Fetch all users
  const fetchUsers = useCallback(async () => {
    try {
      const userRef = collection(db, 'users');
      const snapshot = await getDocs(userRef);
      const usersData = snapshot.docs.map(doc => ({ ...doc.data(), id: doc.id }));
      setUsers(usersData);
    } catch (error) {
      console.error("Error fetching users:", error.message);
    }
  }, []);

  useEffect(() => {
    if (activeTab === 'viewUsers' || activeTab === 'manageUsers') {
      fetchUsers();
    }
  }, [activeTab, fetchUsers]);

  // Remove user with confirmation
  const handleRemoveUser = async (userId) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this member?");
    if (!confirmDelete) return; 

    try {
      await deleteDoc(doc(db, 'users', userId));  
      setUsers(prevUsers => prevUsers.filter(user => user.id !== userId)); 
    } catch (error) {
      console.error("Error removing user:", error.message);
    }
  };

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
  };



  const handleLogout = async () => {
    try {
      await auth.signOut();
      window.location.href = '/';  
    } catch (error) {
      console.error("Error logging out:", error.message);
    }
  };

  useEffect(() => {
    document.body.classList.add('admin-panel-active');
    return () => {
      document.body.classList.remove('admin-panel-active');
    };
  }, []);





//fetch all the messages from the contacts
const [messages, setMessages] = useState([]);

useEffect(() => {
  const fetchMessages = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "contacts"));
      const contactMessages = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setMessages(contactMessages);
    } catch (error) {
      console.error("Error fetching messages:", error);
    }
  };

  fetchMessages();
}, []);







const [submissions, setSubmissions] = useState([]);
const [filters, setFilters] = useState({
  feeType: '',
  month: '',
  name: '',
  status: ''
});


// ✅ Function to generate Exam Application PDF
const generateExamApplication = (submission) => {
  const docPdf = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a5", // A5 size
  });

  // ------------------ Logo ------------------
  const logo = "/round-logo.png";
  docPdf.addImage(logo, "PNG", 10, 10, 25, 25);

  // ------------------ Institute Header ------------------
  docPdf.setFont("times", "bold");
  docPdf.setFontSize(14);
  docPdf.text("EYE CARE INSTITUTE", 70, 20, { align: "center" });

  docPdf.setFontSize(12);
  docPdf.text("College of Optometry & Vision Science", 70, 27, { align: "center" });

  docPdf.setFont("times", "normal");
  docPdf.setFontSize(12);
  docPdf.text("932, Maradana Road, Colombo 08", 70, 34, { align: "center" });
  docPdf.text("Tel: 011 268 2277 / 077 344 0937", 70, 40, { align: "center" });

  // Separator Line
  docPdf.setLineWidth(0.5);
  docPdf.line(10, 45, 140, 45);

  // ------------------ Title ------------------
  docPdf.setFont("times", "bold");
  docPdf.setFontSize(13);
  docPdf.text("EXAM APPLICATION", 70, 55, { align: "center" });

  // ------------------ Student Details ------------------
  docPdf.setFontSize(12);

  let y = 70;

  // ✅ Safely format Firestore Timestamp
  let appliedDate = "";
  if (submission.submittedAt?.seconds) {
    appliedDate = new Date(submission.submittedAt.seconds * 1000).toLocaleDateString();
  } else if (submission.submittedAt) {
    appliedDate = new Date(submission.submittedAt).toLocaleDateString();
  }

  const details = [
     { label: "Exam Applied Date", value: appliedDate || "" }, // ✅ now string
    { label: "Name", value: submission.name || "" },
    { label: "Course", value: submission.course || "" },
    { label: "Module", value: submission.moduleName || "" },
    { label: "NIC / Passport", value: submission.nicPassportNo || "" },
    { label: "Contact No", value: submission.contactNo || "" },
    { label: "Email", value: submission.email || "" },
   
  ];

  details.forEach((item) => {
    // Label bold
    docPdf.setFont("times", "bold");
    docPdf.text(`${item.label}:`, 15, y);

    // Value normal
    docPdf.setFont("times", "normal");
    docPdf.text(String(item.value), 55, y); // force string

    // Separator line
    y += 6;
    docPdf.setLineWidth(0.2);
    docPdf.line(15, y, 165, y);
    y += 4;
  });



docPdf.setFontSize(10);
docPdf.setFont("times", "italic");
docPdf.text("This is a system-generated exam application.", 70, 145, {
  align: "center",
});
  // Save PDF
  docPdf.save(`Exam_Application_${submission.name || "student"}.pdf`);
};




useEffect(() => {
  const fetchSubmissions = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "formSubmissions"));
      const data = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      // Sort by submit date (newest first)
      const sortedData = data.sort((a, b) => {
        // Get submit dates for comparison
        const getSubmitDate = (sub) => {
          if (sub.submittedAt?.seconds) {
            return new Date(sub.submittedAt.seconds * 1000);
          }
          if (sub.submittedAt) {
            return new Date(sub.submittedAt);
          }
          if (sub.date) {
            return new Date(sub.date);
          }
          return new Date(0); // Fallback for submissions without date
        };

        const dateA = getSubmitDate(a);
        const dateB = getSubmitDate(b);
        
        return dateB - dateA; // Descending order (newest first)
      });

      setSubmissions(sortedData);
    } catch (error) {
      console.error("Error fetching submissions:", error);
    }
  };

  fetchSubmissions();
}, []);

const filteredSubmissions = submissions.filter(submission => {

  // Fee Type filter
  if (filters.feeType && submission.feeType !== filters.feeType) {
    return false;
  }

  // Month filter
  if (filters.month) {
    const submissionDate = submission.submittedAt?.seconds
      ? new Date(submission.submittedAt.seconds * 1000)
      : new Date(submission.date || submission.submittedAt);

    const submissionMonth = submissionDate.getMonth() + 1;
    if (submissionMonth !== parseInt(filters.month)) {
      return false;
    }
  }

  // Name filter
  if (
    filters.name &&
    !submission.name?.toLowerCase().includes(filters.name.toLowerCase())
  ) {
    return false;
  }

  // ✅ STATUS FILTER
  if (filters.status) {
    const currentStatus = (submission.status || "pending").toLowerCase();
    if (currentStatus !== filters.status.toLowerCase()) {
      return false;
    }
  }

  return true;
});

// Get unique fee types for dropdown
const uniqueFeeTypes = [...new Set(submissions.map(sub => sub.feeType))].filter(Boolean);


 
  





// Add this function to update status in Firestore
const updateSubmissionStatus = async (submissionId, newStatus) => {
  try {
    await updateDoc(doc(db, "formSubmissions", submissionId), {
      status: newStatus,
      updatedAt: new Date()
    });
    // Update local state to reflect changes immediately
    setSubmissions(submissions.map(sub => 
      sub.id === submissionId ? {...sub, status: newStatus} : sub
    ));
  } catch (error) {
    console.error("Error updating status:", error);
    alert("Failed to update status");
  }
};










// State initialization
const [paymentDate, setPaymentDate] = useState('');
const [studentName, setStudentName] = useState('');
const [studentEmail, setStudentEmail] = useState('');
const [paymentfor, setPaymentfor] = useState('exam');
const [paymentType, setPaymentType] = useState('deposit');
const [PaymentforMonth, setPaymentforMonth] = useState('January');
const [amount, setAmount] = useState('');
const [RecieptOutstandingAmount, setRecieptOutstandingAmount] = useState('');
const [paymentNumber, setPaymentNumber] = useState('0001');
const [remark, setRemark] = useState('');
const [isGenerating, setIsGenerating] = useState(false);


useEffect(() => {
  const initializePaymentNumber = async () => {
    try {
      const paymentsRef = collection(db, "payments");
      const q = query(paymentsRef, orderBy("paymentNumber", "desc"), limit(1));
      const querySnapshot = await getDocs(q);

      if (querySnapshot.empty) {
        // No payments exist yet, start with 0001
        setPaymentNumber('0001');
      } else {
        // Get the last payment number and increment
        const lastPayment = querySnapshot.docs[0].data();
        const lastNumber = lastPayment.paymentNumber;
        
        // Handle both string and number formats
        const num = typeof lastNumber === 'number' ? lastNumber : parseInt(lastNumber, 10);
        const nextNumber = (num + 1).toString().padStart(4, '0');
        setPaymentNumber(nextNumber);
      }
    } catch (error) {
      console.error("Error initializing payment number:", error);
      // Fallback to 0001 if there's an error
      setPaymentNumber('0001');
    }
  };

  initializePaymentNumber();
}, []);




const handleCreatePaymentSlip = async () => {
  if (!paymentDate || !studentName || !studentEmail || !paymentfor || !amount) {
    window.alert("Please fill in all required fields before proceeding!");
    return;
  }

  setIsGenerating(true); 

  const paymentData = {
    paymentDate: String(paymentDate).trim(),
    studentName: String(studentName).trim(),
    studentEmail: String(studentEmail).trim(),
    paymentType: paymentType,
    chequeNumber: chequeNumber || "",
    paymentfor: paymentfor,
    PaymentforMonth: PaymentforMonth,
    amount: parseFloat(amount) || 0,
    RecieptOutstandingAmount: parseFloat(RecieptOutstandingAmount) || 0,
    remark: String(remark).trim(),
    paymentNumber: paymentNumber, 
    createdAt: new Date(),
  };

  try {
    // Save to Firestore
    await addDoc(collection(db, "payments"), paymentData);


// Create PDF
const doc = new jsPDF({
  orientation: "landscape",
  unit: "mm",
  format: [210, 148],
});

const pageWidth = doc.internal.pageSize.getWidth();
const pageHeight = doc.internal.pageSize.getHeight();

const margin = {
  left: 20,
  right: 20,
  top: 25,
  bottom: 20,
};

const contentWidth = pageWidth - margin.left - margin.right;
const logo = "/round-logo.png"; // Ensure this path is correct

// --- Header ---
doc.setFillColor(21, 27, 84);
doc.rect(0, 0, pageWidth, margin.top, "F");

doc.addImage(logo, "PNG", margin.left, 2, 20, 20);

doc.setFontSize(16);
doc.setTextColor(255, 255, 255);
doc.text("Eye Care Institute", pageWidth / 2, 10, { align: "center" });
doc.setFontSize(10);
doc.text("College of Optometry and Vision Science", pageWidth / 2, 16, { align: "center" });

// --- Payment Slip Title ---
doc.setFont("helvetica", "bold");
doc.setFontSize(14);
doc.setTextColor(0, 0, 0);
doc.text("PAYMENT SLIP", pageWidth / 2, margin.top + 10, { align: "center" });

// --- Payment Details ---
doc.setFontSize(10);
let y = margin.top + 20;

doc.text(`Payment No: ${paymentNumber}`, margin.left, y);
doc.text(`Date: ${paymentData.paymentDate}`, pageWidth - margin.right, y, { align: "right" });

y += 10;
doc.text("Student Name:", margin.left, y);
doc.text(paymentData.studentName, margin.left + 35, y);

y += 7;
doc.text("Student Email:", margin.left, y);
doc.text(paymentData.studentEmail, margin.left + 35, y);

y += 7;
doc.text("Payment For:", margin.left, y);
doc.text(
  paymentData.paymentfor === 'exam' ? 'Exam Fee' : 
  paymentData.paymentfor === 'admission' ? 'Admission Fee' :
  paymentData.paymentfor === 'Convocation Fee' ? 'Convocation Fee' :
  paymentData.paymentfor === 'other' ? 'Other' :
  paymentData.paymentfor === 'nvq rpl' ? 'NVQ RPL Fee' :
  paymentData.paymentfor === 'nvq fee' ? 'NVQ Fee' :
  paymentData.paymentfor === 'surcharge' ? 'Surcharge' :
  paymentData.paymentfor === 'registration' ? 'Registration Fee' : 'Class Fee', 
  margin.left + 35, y
);

y += 7;
doc.text("Payment Type:", margin.left, y);

if (paymentData.paymentType === 'deposit') {
  doc.text("Deposit", margin.left + 35, y);
} else if (paymentData.paymentType === 'bank_transfer') {
  doc.text("Bank Transfer", margin.left + 35, y);
} else if (paymentData.paymentType === 'cheque') {
  doc.text("Cheque", margin.left + 35, y);
  y += 7;
 doc.text(`Cheque No:`, margin.left, y);
    doc.text(paymentData.chequeNumber || "-", margin.left + 35, y);
}

y += 7;
doc.text("Payment Month:", margin.left, y);
doc.text(paymentData.PaymentforMonth || "-", margin.left + 35, y);

// --- Amount Section ---
y += 13;
doc.line(margin.left, y - 3, pageWidth - margin.right, y - 3);

doc.setFont("helvetica", "bold");
doc.text("Amount Paid:", margin.left, y);
doc.text(`Rs. ${paymentData.amount.toFixed(2)}`, pageWidth - margin.right, y, { align: "right" });

y += 13;
doc.text("Outstanding Amount:", margin.left, y);
doc.text(`Rs. ${paymentData.RecieptOutstandingAmount.toFixed(2)}`, pageWidth - margin.right, y, { align: "right" });



y += 10;
doc.text("Remark:", margin.left, y);
doc.text(paymentData.remark || "-", margin.left + 35, y);



// --- Footer ---
doc.setFontSize(8);
doc.setTextColor(100, 100, 100);
doc.text("932, Maradana Road, Colombo 08", pageWidth / 2, pageHeight - 15, { align: "center" });
doc.text("Email: ecinstitute@gmail.com | Phone: 011-268-22-77", pageWidth / 2, pageHeight - 10, { align: "center" });
doc.text("Website: www.eyecareinstitute.lk", pageWidth / 2, pageHeight - 5, { align: "center" });

// Save the PDF
doc.save(`Payment-${paymentNumber}.pdf`);

    // Calculate next payment number (current + 1)
    const nextNumber = (parseInt(paymentNumber, 10) + 1).toString().padStart(4, '0');
    setPaymentNumber(nextNumber);

    // Reset form fields (except payment number)
    setPaymentDate('');
    setStudentName('');
    setStudentEmail('');
    setPaymentfor('exam');
    setPaymentType('deposit');
    setRemark('');
    setAmount('');

    setIsGenerating(false); 


  } catch (error) {
    console.error("Error creating payment slip: ", error);
    window.alert("Error generating payment slip. Please try again.");
  }
};





const ViewPaymentHistory = () => {
  // All hooks must be at the top level
  const [payments, setPayments] = useState([]);
  const [filteredPayments, setFilteredPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [deletingId, setDeletingId] = useState(null);
  const [filters, setFilters] = useState({
    year: '',
    month: '',
    paymentFor: ''
  });
  

  // Payment for options
  const paymentForOptions = [
    { value: '', label: 'All Types' },
    { value: 'exam', label: 'Exam Fee' },
    { value: 'admission', label: 'Admission Fee' },
    { value: 'nvq rpl', label: 'NVQ RPL Fee' },
    { value: 'nvq fee', label: 'NVQ Fee' },
    { value: 'Convocation Fee', label: 'Convocation Fee' },
    { value: 'other', label: 'Other' },
    { value: 'surcharge', label: 'Surcharge' },
    { value: 'registration', label: 'Registration Fee' },
    { value: 'class', label: 'Class Fee' }
  ];

  // Get unique years from payments
  const getUniqueYears = () => {
    const years = new Set();
    payments.forEach(payment => {
      if (payment.paymentDate) {
        years.add(new Date(payment.paymentDate).getFullYear());
      }
    });
    return Array.from(years).sort((a, b) => b - a);
  };

  useEffect(() => {
    const fetchPayments = async () => {
      try {
        const paymentsRef = collection(db, 'payments');
        const q = query(paymentsRef, orderBy('paymentDate', 'desc'));
        
        const unsubscribe = onSnapshot(q, (querySnapshot) => {
          const paymentsData = [];
          querySnapshot.forEach((doc) => {
            paymentsData.push({
              id: doc.id,
              ...doc.data()
            });
          });
          setPayments(paymentsData);
          setLoading(false);
        });

        return () => unsubscribe();
      } catch (err) {
        setError(err.message);
        setLoading(false);
        console.error("Error fetching payments: ", err);
      }
    };

    fetchPayments();
  }, []);

  useEffect(() => {
    let filtered = [...payments];
    
    // Apply search term filter
    if (searchTerm.trim() !== '') {
      filtered = filtered.filter(payment => 
        payment.studentName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        payment.studentEmail.toLowerCase().includes(searchTerm.toLowerCase()) ||
        payment.paymentfor.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
    
    // Apply year filter
    if (filters.year) {
      filtered = filtered.filter(payment => {
        if (!payment.paymentDate) return false;
        return new Date(payment.paymentDate).getFullYear() === parseInt(filters.year);
      });
    }
    
    // Apply month filter
    if (filters.month) {
      filtered = filtered.filter(payment => {
        if (!payment.paymentDate) return false;
        return new Date(payment.paymentDate).getMonth() + 1 === parseInt(filters.month);
      });
    }
    
    // Apply paymentFor filter
    if (filters.paymentFor) {
      filtered = filtered.filter(payment => 
        payment.paymentfor === filters.paymentFor
      );
    }
    
    setFilteredPayments(filtered);
  }, [searchTerm, payments, filters]);

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  const formatPaymentFor = (type) => {
    switch(type) {
      case 'exam': return 'Exam Fee';
      case 'admission': return 'Admission Fee';
      case 'nvq rpl': return 'NVQ RPL Fee';
      case 'nvq fee': return 'NVQ Fee';
      case 'Convocation Fee': return 'Convocation Fee';
      case 'other': return 'Other';
      case 'surcharge': return 'Surcharge';
      case 'registration': return 'Registration Fee';
      case 'class': return 'Class Fee';
      default: return type;
    }
  };







  const exportToExcel = () => {
    if (filteredPayments.length === 0) {
      alert('No data to export!');
      return;
    }
    
const worksheet = XLSX.utils.json_to_sheet(
  filteredPayments.map(payment => ({
    'Payment Number': payment.paymentNumber || '-',
    'Date': formatDate(payment.paymentDate),
    'Student Name': payment.studentName || '-',
    'Student Email': payment.studentEmail || '-',
    'Payment Type':
      payment.paymentType === 'deposit'
        ? 'Deposit'
        : payment.paymentType === 'bank_transfer'
        ? 'Bank Transfer'
        : payment.paymentType === 'cheque'
        ? 'Cheque'
        : 'Other',
    'Cheque No':
      payment.paymentType === 'cheque'
        ? payment.chequeNumber || '-'
        : '',
    'Payment For': formatPaymentFor(payment.paymentfor),
    'Payment for Month': payment.PaymentforMonth || '-',
    'Amount (LKR)': payment.amount ? payment.amount.toFixed(2) : '0.00',
    'Outstanding Amount (LKR)': payment.RecieptOutstandingAmount
      ? payment.RecieptOutstandingAmount.toFixed(2)
      : '0.00',
      'Remark': payment.remark || '-',
  }))
);


    
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Payment History");
    
    // Generate filename based on filters
    let filename = "Payment_History";
    if (filters.year) filename += `_${filters.year}`;
    if (filters.month) filename += `_${filters.month}`;
    if (filters.paymentFor) filename += `_${filters.paymentFor}`;
    
    XLSX.writeFile(workbook, `${filename}.xlsx`);
  };




  const handleDeletePayment = async (paymentId) => {
    if (!window.confirm('Are you sure you want to delete this payment record? This action cannot be undone.')) {
      return;
    }
    
    try {
      setDeletingId(paymentId);
      await deleteDoc(doc(db, 'payments', paymentId));
    } catch (err) {
      console.error("Error deleting payment: ", err);
      alert('Failed to delete payment. Please try again.');
    } finally {
      setDeletingId(null);
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const resetFilters = () => {
    setFilters({
      year: '',
      month: '',
      paymentFor: ''
    });
    setSearchTerm('');
  };

const downloadPaymentSlip = (payment) => {
  const doc = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: [210, 148], // Half A4 (A5 size)
  });

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  // Define uniform margins
  const margin = {
    left: 20,
    right: 20,
    top: 25,
    bottom: 20,
  };

  const logo = "/round-logo.png";

  // --- Header ---
  doc.setFillColor(21, 27, 84);
  doc.rect(0, 0, pageWidth, margin.top, "F");
  doc.addImage(logo, "PNG", margin.left, 2, 20, 20);

  doc.setFontSize(16);
  doc.setTextColor(255, 255, 255);
  doc.text("Eye CARE INSTITUTE", pageWidth / 2, 10, { align: "center" });
  doc.setFontSize(10);
  doc.text("College of Optometry and Vision Science", pageWidth / 2, 16, { align: "center" });

  // --- Payment Slip Title ---
  doc.setFont("helvetica", "bold");
  doc.setFontSize(14);
  doc.setTextColor(0, 0, 0);
  doc.text("PAYMENT SLIP", pageWidth / 2, margin.top + 10, { align: "center" });

  // --- Payment Details ---
  doc.setFontSize(10);
  let y = margin.top + 20;

  doc.text(`Payment No: ${payment.paymentNumber}`, margin.left, y);
  doc.text(`Date: ${formatDate(payment.paymentDate)}`, pageWidth - margin.right, y, { align: "right" });

  y += 10;
  doc.text("Student Name:", margin.left, y);
  doc.text(payment.studentName, margin.left + 35, y);

  y += 7;
  doc.text("Student Email:", margin.left, y);
  doc.text(payment.studentEmail, margin.left + 35, y);

  y += 7;
  doc.text("Payment For:", margin.left, y);
  doc.text(
    payment.paymentfor === "exam"
      ? "Exam Fee"
      : payment.paymentfor === "admission"
      ? "Admission Fee"
      : payment.paymentfor === "other"
      ? "Other"
      : payment.paymentfor === "Convocation Fee"
      ? "Convocation Fee"
      : payment.paymentfor === "nvq rpl"
      ? "NVQ RPL Fee"
      : payment.paymentfor === "nvq fee"
      ? "NVQ Fee"
      : payment.paymentfor === "surcharge"
      ? "Surcharge"
      : payment.paymentfor === "registration"
      ? "Registration Fee"
      : "Class Fee",
    margin.left + 35,
    y
  );

  // --- Payment Type (with cheque number) ---
  y += 7;
  doc.text("Payment Type:", margin.left, y);

  if (payment.paymentType === "deposit") {
    doc.text("Deposit", margin.left + 35, y);
  } else if (payment.paymentType === "bank_transfer") {
    doc.text("Bank Transfer", margin.left + 35, y);
  } else if (payment.paymentType === "cheque") {
    doc.text("Cheque", margin.left + 35, y);
    y += 7;
    doc.text(`Cheque No:`, margin.left, y);
    doc.text(payment.chequeNumber || "-", margin.left + 35, y);
  }

  // --- Payment Month ---
  y += 7;
  doc.text("Payment Month:", margin.left, y);
  doc.text(payment.PaymentforMonth || "-", margin.left + 35, y);


  // --- Amount ---
  y += 13;
  doc.line(margin.left, y - 3, pageWidth - margin.right, y - 3);

  doc.setFont("helvetica", "bold");
  doc.text("Amount Paid:", margin.left, y);
  doc.text(`Rs. ${payment.amount.toFixed(2)}`, pageWidth - margin.right, y, { align: "right" });

  y += 13;
  doc.text("Outstanding Amount:", margin.left, y);
  doc.text(`Rs. ${payment.RecieptOutstandingAmount.toFixed(2)}`, pageWidth - margin.right, y, { align: "right" });


  y += 10;
  doc.text("Remark:", margin.left, y);
doc.text(payment.remark || "-", margin.left + 35, y);


  // --- Footer ---
  doc.setFontSize(8);
  doc.setTextColor(100, 100, 100);
  doc.text("932, Maradana Road, Colombo 08", pageWidth / 2, pageHeight - 15, { align: "center" });
  doc.text("Email: ecinstitute@gmail.com | Phone: 011-268-22-77", pageWidth / 2, pageHeight - 10, { align: "center" });
  doc.text("Website: www.eyecareinstitute.lk", pageWidth / 2, pageHeight - 5, { align: "center" });

  // --- Save PDF ---
  doc.save(`Payment-${payment.paymentNumber}.pdf`);
};

 

  if (loading) return <div className="loading">Loading payment history...</div>;
  if (error) return <div className="error">Error: {error}</div>;

  return (
    <div className="view-payment-history">
      <div className="payment-history-header">
        <h3>View Payment History</h3>
        <div className="payment-history-filters">
          <div className="filter-group">
            <label>Year:</label>
            <select 
              name="year" 
              value={filters.year} 
              onChange={handleFilterChange}
            >
              <option value="">All Years</option>
              {getUniqueYears().map(year => (
                <option key={year} value={year}>{year}</option>
              ))}
            </select>
          </div>
          
          <div className="filter-group">
            <label>Month:</label>
            <select 
              name="month" 
              value={filters.month} 
              onChange={handleFilterChange}
            >
              <option value="">All Months</option>
              {Array.from({length: 12}, (_, i) => i + 1).map(month => (
                <option key={month} value={month}>
                  {new Date(0, month - 1).toLocaleString('default', {month: 'long'})}
                </option>
              ))}
            </select>
          </div>
          
          <div className="filter-group">
            <label>Payment For:</label>
            <select 
              name="paymentFor" 
              value={filters.paymentFor} 
              onChange={handleFilterChange}
            >
              {paymentForOptions.map(option => (
                <option key={option.value} value={option.value}>{option.label}</option>
              ))}
            </select>
          </div>
          




          <button onClick={resetFilters} className="reset-filters">
            Reset Filters
          </button>

                      <button 
    onClick={exportToExcel} 
    className="export-excel-btn"
    disabled={filteredPayments.length === 0}
  >
    Export to Excel
  </button>

  
        </div>
        
        {/* <div className="payment-history-actions">
          <div className="search-box">
            <input
              type="text"
              placeholder="Search by name or email..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <span className="search-icon">🔍</span>
          </div>
          <button 
            onClick={exportToExcel} 
            className="export-excel-btn"
            disabled={filteredPayments.length === 0}
          >
            Export to Excel
          </button>
        </div> */}

        <div className="search-export-section">
  <div className="search-box">
    <input
      type="text"
      placeholder="Search by name or email..."
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
    />
    <span className="search-icon">🔍</span>
  </div>


</div>

      </div>
      
      {filteredPayments.length === 0 ? (
        <div className="no-payments">
          {payments.length === 0 ? 'No payment records found.' : 'No matching payments found.'}
        </div>
      ) : (
        <div className="payments-table-container">
          <div className="filter-summary">
            Showing {filteredPayments.length} of {payments.length} payments
            {filters.year && ` in ${filters.year}`}
            {filters.month && `, ${new Date(0, filters.month - 1).toLocaleString('default', {month: 'long'})}`}
            {filters.paymentFor && `, ${paymentForOptions.find(o => o.value === filters.paymentFor)?.label}`}
          </div>

          <table className="payments-table">
            <thead>
              <tr>
                <th>Payment #</th>
                <th>Date</th>
                <th>Student Name</th>
                <th>Student Email</th>
                {/* <th>Course</th>
                <th>Module Name</th> */}
                <th>Payment Type</th>
                <th>Payment For</th>
                <th>Amount (LKR)</th>
                <th>Payment Slip</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredPayments.map((payment) => (
                <tr key={payment.id}>
                  <td>{payment.paymentNumber}</td>
                  <td>{formatDate(payment.paymentDate)}</td>
                  <td>{payment.studentName}</td>
                  <td>{payment.studentEmail}</td>
                  {/* <th>{payment.course}</th>
                  <th>{payment.moduleName}</th> */}
            <td>
  {payment.paymentType === 'deposit'
    ? 'Deposit'
    : payment.paymentType === 'bank_transfer'
    ? 'Bank Transfer'
    : payment.paymentType === 'cheque'
    ? `Cheque${payment.chequeNumber ? ` - ${payment.chequeNumber}` : ''}`
    : 'Other'}
</td>

                  <td>{formatPaymentFor(payment.paymentfor)}</td>
                  <td className="amount">{payment.amount.toFixed(2)}</td>
                  <td>
                    <button onClick={() => downloadPaymentSlip(payment)}>Download</button>
                  </td>
                  <td>
                    <button 
                      onClick={() => handleDeletePayment(payment.id)}
                      disabled={deletingId === payment.id}
                      className="delete-btn"
                    >
                      {deletingId === payment.id ? 'Deleting...' : 'Delete'}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};













// // Add this function to your ViewPaymentHistory component
//  const downloadPaymentSlip = (payment) => {
//   const doc = new jsPDF({
//     orientation: "landscape",
//     unit: "mm",
//     format: [210, 148], // Half A4 (similar to A5 portrait)
//   });

//   // --- Header ---
//   doc.setFillColor(21, 27, 84);
//   doc.rect(0, 0, doc.internal.pageSize.getWidth(), 25, "F");
//   doc.setFontSize(16);
//   doc.setTextColor(255, 255, 255);
//   doc.text("Eye CARE INSTITUTE", doc.internal.pageSize.getWidth() / 2, 12, { align: "center" });
//   doc.setFontSize(10);
//   doc.text("College of Optometry and Vision Science", doc.internal.pageSize.getWidth() / 2, 18, { align: "center" });

//   // --- Payment Slip Title ---
//   doc.setFont("helvetica", "bold");
//   doc.setFontSize(14);
//   doc.setTextColor(0, 0, 0);
//   doc.text("PAYMENT SLIP", doc.internal.pageSize.getWidth() / 2, 35, { align: "center" });

//   // --- Payment Details ---
//   doc.setFontSize(10);
//   doc.text(`Payment No: ${payment.paymentNumber}`, 10, 45);
//   doc.text(`Date: ${payment.paymentDate}`, doc.internal.pageSize.getWidth() - 10, 45, { align: "right" });

//   doc.text("Student Name:", 10, 55);
//   doc.text(payment.studentName, 40, 55);

//   doc.text("Student Email:", 10, 62);
//   doc.text(payment.studentEmail, 40, 62);


// doc.text(
//   payment.paymentfor === 'exam' ? 'Exam Fee' : 
//   payment.paymentfor === 'admission' ? 'Admission Fee' :
//   payment.paymentfor === 'registration' ? 'Registration Fee' : 'Class Fee', 
//   40, 69
// );

//   doc.text("Payment Type:", 10, 76);
//   doc.text(payment.paymentType === 'deposit' ? 'Deposit' : 'Bank Transfer', 40, 76);

//   // --- Amount ---
//   doc.setFont("helvetica", "bold");
//   doc.text("Amount Paid:", 10, 89);
//   doc.text(`Rs. ${payment.amount.toFixed(2)}`, doc.internal.pageSize.getWidth() - 10, 89, { align: "right" });
//   doc.line(10, 93, doc.internal.pageSize.getWidth() - 10, 93);

//   // --- Footer ---
//   doc.setFontSize(8);
//   doc.setTextColor(100, 100, 100);
//   doc.text("932, Maradana Road, Colombo 08", doc.internal.pageSize.getWidth() / 2, 130, { align: "center" });
//   doc.text("Email: ecinstitute@gmail.com | Phone: 011-268-22-77", doc.internal.pageSize.getWidth() / 2, 135, { align: "center" });
//   doc.text("Website: www.eyecareinstitute.lk", doc.internal.pageSize.getWidth() / 2, 140, { align: "center" });

//   // Save the PDF
//   doc.save(`Payment-${payment.paymentNumber}.pdf`);
// };









//certificate verification 

   const [formData, setFormData] = useState({
    certificateId: '',
    studentName: '',
    nicNo: '',
    course: '',
    issueDate: ''
  });
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    try {
      await addDoc(collection(db, 'verificationCertificates'), {
        ...formData,
    issueDate: new Date(formData.issueDate), // 👈 convert string to Date
    createdAt: serverTimestamp(),
      });
      
      setSuccess(true);
      setFormData({
        certificateId: '',
        studentName: '',
        nicNo: '',
        course: '',
        issueDate: ''
      });
      
      setTimeout(() => setSuccess(false), 3000);
    } catch (err) {
      console.error('Error adding certificate:', err);
      setError('Failed to add certificate');
    }
  };




/*******************************************/

  const [certificates, setCertificates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [deletingId, setDeletingId] = useState(null);
  const [editingId, setEditingId] = useState(null);
  const [sortConfig, setSortConfig] = useState({ key: 'createdAt', direction: 'desc' });
  const [searchTerm, setSearchTerm] = useState('');
  const [yearFilter, setYearFilter] = useState('');
  const [editForm, setEditForm] = useState({
    studentName: '',
    nicNo: '',
    course: ''
  });

  useEffect(() => {
    if (activeTab === 'allCertificates') {
      fetchCertificates();
    }
  }, [activeTab]);

  const fetchCertificates = async () => {
    try {
      setLoading(true);
      const querySnapshot = await getDocs(collection(db, 'verificationCertificates'));
      const certificatesData = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setCertificates(certificatesData);
    } catch (err) {
      toast.error('Failed to fetch certificates');
      console.error('Error:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this certificate?')) return;
    
    try {
      setDeletingId(id);
      await deleteDoc(doc(db, 'verificationCertificates', id));
      setCertificates(certificates.filter(cert => cert.id !== id));
      toast.success('Certificate deleted successfully');
    } catch (err) {
      toast.error('Failed to delete certificate');
      console.error('Error:', err);
    } finally {
      setDeletingId(null);
    }
  };

  const handleEdit = (certificate) => {
    setEditingId(certificate.id);
    setEditForm({
      studentName: certificate.studentName,
      nicNo: certificate.nicNo,
      course: certificate.course
    });
  };

  const handleSaveEdit = async () => {
    try {
      // Implement your Firestore update logic here
      // await updateDoc(doc(db, 'verificationCertificates', editingId), editForm);
      setCertificates(certificates.map(cert => 
        cert.id === editingId ? { ...cert, ...editForm } : cert
      ));
      toast.success('Certificate updated successfully');
      setEditingId(null);
    } catch (err) {
      toast.error('Failed to update certificate');
      console.error('Error:', err);
    }
  };

  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  const filteredCertificates = useCallback(() => {
    let result = [...certificates];
    
    // Apply search filter
    if (searchTerm) {
      const term = searchTerm.toLowerCase();
      result = result.filter(cert => 
        cert.studentName?.toLowerCase().includes(term) ||
        cert.nicNo?.toLowerCase().includes(term) ||
        cert.course?.toLowerCase().includes(term)
  )}
    
    // Apply year filter
    if (yearFilter) {
      result = result.filter(cert => {
        if (!cert.issueDate) return false;
        const issueYear = cert.issueDate.toDate().getFullYear();
        return issueYear.toString() === yearFilter;
      });
    }
    
    return result;
  }, [certificates, searchTerm, yearFilter]);

  const sortedCertificates = filteredCertificates().sort((a, b) => {
    if (a[sortConfig.key] < b[sortConfig.key]) {
      return sortConfig.direction === 'asc' ? -1 : 1;
    }
    if (a[sortConfig.key] > b[sortConfig.key]) {
      return sortConfig.direction === 'asc' ? 1 : -1;
    }
    return 0;
  });

  const formatDate = (timestamp) => {
    if (!timestamp) return 'N/A';
    const date = timestamp.toDate();
    return date.toLocaleString('en-US', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  // Generate year options from 2007 to 2035
  const yearOptions = Array.from({ length: 29 }, (_, i) => 2007 + i);




///////////////////////Summary - daily, weekly, monthly///////////////////////////////////////////////////////////////////////////////////////
  const [payments, setPayments] = useState([]);
  const [summary, setSummary] = useState(0);

  // Filters
  const [year, setYear] = useState(dayjs().year());
  const [filterMode, setFilterMode] = useState("daily"); // daily | monthly
  const [selectedDate, setSelectedDate] = useState(dayjs().format("YYYY-MM-DD"));
  const [selectedMonth, setSelectedMonth] = useState(dayjs().month() + 1);
  const [paymentFor, setPaymentFor] = useState("All"); // ✅ new filter

  // Chart data
  const [chartData, setChartData] = useState([]);

  // Fetch payments
  useEffect(() => {
    const fetchPayments = async () => {
      const querySnapshot = await getDocs(collection(db, "payments"));
      const list = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setPayments(list);
    };
    fetchPayments();
  }, []);

  // Calculate summary
  useEffect(() => {
    let total = 0;

    payments.forEach((p) => {
      const d = dayjs(p.paymentDate, "YYYY-MM-DD");

      if (d.year() !== Number(year)) return;
      if (paymentType !== "All" && p.paymentType !== paymentType) return;
      if (paymentFor !== "All" && p.paymentfor !== paymentFor) return; // ✅ filter by paymentfor

      if (filterMode === "daily") {
        if (d.isSame(dayjs(selectedDate, "YYYY-MM-DD"), "day")) {
          total += Number(p.amount) || 0;
        }
      } else if (filterMode === "monthly") {
        if (d.month() + 1 === Number(selectedMonth)) {
          total += Number(p.amount) || 0;
        }
      }
    });

    setSummary(total);
  }, [payments, year, paymentType, paymentFor, filterMode, selectedDate, selectedMonth]);

  // Prepare chart data (monthly totals)
  useEffect(() => {
    const monthlyTotals = Array(12).fill(0);

    payments.forEach((p) => {
      const d = dayjs(p.paymentDate, "YYYY-MM-DD");
      if (d.year() !== Number(year)) return;
      if (paymentType !== "All" && p.paymentType !== paymentType) return;
      if (paymentFor !== "All" && p.paymentfor !== paymentFor) return; // ✅ filter by paymentfor

      const monthIndex = d.month(); // 0 = Jan
      monthlyTotals[monthIndex] += Number(p.amount) || 0;
    });

    const formatted = monthlyTotals.map((amt, i) => ({
      month: dayjs().month(i).format("MMM"),
      income: amt,
    }));

    setChartData(formatted);
  }, [payments, year, paymentType, paymentFor]);






////////////////////////////////////////////// Paid / Not-Paid/////////////////////////////////////////////////////////////////
   const [csvData, setCsvData] = useState([]);
  const [results, setResults] = useState(null);
  const [availableMonths, setAvailableMonths] = useState([]);
  const fileInputRef = useRef(null);

  // Extract batch from registration number
  const extractBatch = (registrationNumber) => {
    if (!registrationNumber) return 'Unknown';
    const parts = registrationNumber.split('-');
    if (parts.length >= 2) {
      const yearPart = parts[1];
      if (yearPart && yearPart.length >= 4) {
        const year = yearPart.substring(0, 4);
        const batchNumber = yearPart.substring(4, 6) || '01';
        return `${year}-${batchNumber}`;
      }
    }
    return 'Unknown';
  };

  // Extract course from registration number
  const extractCourse = (registrationNumber) => {
    if (!registrationNumber) return 'Unknown';
    if (registrationNumber.startsWith('CO-')) return 'Certificate in Optician';
    if (registrationNumber.startsWith('DO-')) return 'Diploma in Optometry';
    if (registrationNumber.startsWith('AD-')) return 'Advanced Diploma';
    if (registrationNumber.startsWith('BO-')) return 'Bachelor of Optometry';
    return 'Unknown';
  };

  // Extract month from payment date
  const extractMonth = (paymentDate) => {
    if (!paymentDate) return 'Unknown';
    try {
      const date = new Date(paymentDate);
      if (isNaN(date.getTime())) return 'Unknown';
      const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
      return monthNames[date.getMonth()];
    } catch (error) {
      return 'Unknown';
    }
  };

  // Handle CSV file upload
  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    Papa.parse(file, {
      header: true,
      complete: (result) => {
        const processedData = result.data
          .filter(row => row.studentEmail && row.studentEmail.trim() !== '')
          .map(row => ({
            ...row,
            registrationNumber: row.registrationNumber || row.studentEmail,
            batch: extractBatch(row.registrationNumber || row.studentEmail),
            course: extractCourse(row.registrationNumber || row.studentEmail)
          }));
        
        setCsvData(processedData);
      },
      error: (error) => {
        console.error('Error parsing CSV:', error);
        alert('Error parsing CSV file.');
      }
    });
  };

  // Fetch class payments and extract available months
  const fetchClassPayments = async () => {
    try {
      const paymentsRef = collection(db, 'payments');
      const querySnapshot = await getDocs(paymentsRef);
      const classPayments = [];
      const monthsSet = new Set();
      
      querySnapshot.forEach((doc) => {
        const paymentData = { id: doc.id, ...doc.data() };
        paymentData.month = extractMonth(paymentData.paymentDate || paymentData.createdAt);
        
        // ONLY INCLUDE CLASS PAYMENTS
        if (paymentData.paymentfor === 'class') {
          classPayments.push(paymentData);
          if (paymentData.month !== 'Unknown') {
            monthsSet.add(paymentData.month);
          }
        }
      });
      
      // Set available months
      const months = [...monthsSet].sort((a, b) => {
        const monthOrder = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        return monthOrder.indexOf(a) - monthOrder.indexOf(b);
      });
      
      setAvailableMonths(months);
      return classPayments;
    } catch (error) {
      console.error('Error fetching payments:', error);
      throw error;
    }
  };

  // Analyze class payments for selected month
  const analyzeClassPayments = async () => {
    if (csvData.length === 0) {
      alert('Please upload a CSV file first.');
      return;
    }

    if (!selectedMonth) {
      alert('Please select a month.');
      return;
    }

    setLoading(true);

    try {
      // Fetch class payments
      const classPayments = await fetchClassPayments();
      
      // Filter payments for selected month
      const monthlyPayments = classPayments.filter(payment => payment.month === selectedMonth);
      
      // Create set of paid student emails for this month
      const paidEmails = new Set();
      monthlyPayments.forEach(payment => {
        if (payment.studentEmail) {
          paidEmails.add(payment.studentEmail.toLowerCase().trim());
        }
      });

      // Categorize students
      const paidStudents = [];
      const nonPaidStudents = [];
      const batchCounts = {};
      const courseCounts = {};

      csvData.forEach(student => {
        const studentEmail = student.studentEmail?.toLowerCase().trim();
        const hasPaid = studentEmail && paidEmails.has(studentEmail);
        
        // Initialize counts
        if (!batchCounts[student.batch]) {
          batchCounts[student.batch] = { paid: 0, nonPaid: 0, total: 0 };
        }
        if (!courseCounts[student.course]) {
          courseCounts[student.course] = { paid: 0, nonPaid: 0, total: 0 };
        }

        // Update counts
        batchCounts[student.batch].total++;
        courseCounts[student.course].total++;
        
        if (hasPaid) {
          paidStudents.push(student);
          batchCounts[student.batch].paid++;
          courseCounts[student.course].paid++;
        } else {
          nonPaidStudents.push(student);
          batchCounts[student.batch].nonPaid++;
          courseCounts[student.course].nonPaid++;
        }
      });

      // Calculate totals
      const totalCounts = {
        paid: paidStudents.length,
        nonPaid: nonPaidStudents.length,
        total: csvData.length
      };

      setResults({
        paidStudents,
        nonPaidStudents,
        totalCounts,
        batchCounts,
        courseCounts,
        paymentRecords: monthlyPayments.length,
        analysisMonth: selectedMonth
      });

    } catch (error) {
      console.error('Error analyzing data:', error);
      alert('Error analyzing data.');
    } finally {
      setLoading(false);
    }
  };

  // Reset analysis
  const resetAnalysis = () => {
    setSelectedMonth('');
    setResults(null);
  };




  return (
    <div className="admin-panel">
      <div className="top-bar">
        <ul className="tabs">
          <li className={`tab ${activeTab === 'viewAllSubmission' ? 'active' : ''}`} onClick={() => handleTabClick('viewAllSubmission')}>
            View all payment submissions
          </li>

          <li className={`tab ${activeTab === 'createPaymentSlip' ? 'active' : ''}`} onClick={() => handleTabClick('createPaymentSlip')}>
            Create payment slips
          </li>

          <li className={`tab ${activeTab === 'viewPaymentHistory' ? 'active' : ''}`} onClick={() => handleTabClick('viewPaymentHistory')}>
            View Payment History
          </li>

          <li className={`tab ${activeTab === 'paidStatus' ? 'active' : ''}`} onClick={() => handleTabClick('paidStatus')}>
            Paid / Non-Paid Students
          </li>


          <li className={`tab ${activeTab === 'summary' ? 'active' : ''}`} onClick={() => handleTabClick('summary')}>
            Summary
          </li>


          <li className={`tab ${activeTab === 'studentVerification' ? 'active' : ''}`} onClick={() => handleTabClick('studentVerification')}>
            Certificate Verification System
          </li>



          <li className={`tab ${activeTab === 'allCertificates' ? 'active' : ''}`} onClick={() => handleTabClick('allCertificates')}>
            All Certificates
          </li>

          {/* <li className={`tab ${activeTab === 'manageUsers' ? 'active' : ''}`} onClick={() => handleTabClick('manageUsers')}>
            Manage Members
          </li> */}


          <li className={`tab ${activeTab === 'attendance' ? 'active' : ''}`} onClick={() => window.open("https://ec-attendance-system.eyecareinstitute.lk/", "_blank")}>
            Attendance System
          </li>

          <li className={`tab ${activeTab === 'contactMessage' ? 'active' : ''}`} onClick={() => handleTabClick('contactMessage')}>
            Contact Us Messages
          </li>
        </ul>
        <button className="logout-btn" onClick={handleLogout}>
          Logout
        </button>
      </div>

      <div className="main-content">



{/******************************************************************************************************************************/}

 {activeTab === 'paidStatus' && (
<div className="paid-status-content">
  <h2>Class Payment Analysis</h2>
  
  {/* Add this download button section */}
  <div className="download-section">
    <a 
      href="/studentslist.csv" 
      download="studentslist.csv"
      className="download-btn"
    >
      📥 Download studentslist.csv 
    </a>
    <span className="download-info"> Use this data set to analyze class payments</span>
  </div>
          
          {/* File Upload */}
          <div className="upload-section">
            <input
              type="file"
              accept=".csv"
              onChange={handleFileUpload}
              ref={fileInputRef}
              style={{ display: 'none' }}
            />
            <button
              className="upload-btn"
              onClick={() => fileInputRef.current?.click()}
            >
              Upload CSV File
            </button>
            {csvData.length > 0 && (
              <span className="file-info">
                {csvData.length} students loaded
              </span>
            )}
          </div>

          {/* Month Selection - ONLY FILTER */}
          <div className="month-selection">
            <div className="filter-group">
              <label>Select Month:</label>
              <select
                value={selectedMonth}
                onChange={(e) => setSelectedMonth(e.target.value)}
                disabled={loading}
              >
                <option value="">Choose Month</option>
                {availableMonths.map(month => (
                  <option key={month} value={month}>{month}</option>
                ))}
              </select>
            </div>

            <div className="action-buttons">
              <button
                className="analyze-btn"
                onClick={analyzeClassPayments}
                disabled={loading || !selectedMonth || csvData.length === 0}
              >
                {loading ? 'Analyzing...' : 'Analyze Class Payments'}
              </button>
              
              <button
                className="reset-btn"
                onClick={resetAnalysis}
                disabled={loading}
              >
                Reset
              </button>
            </div>
          </div>

          {/* Results */}
          {results && (
            <div className="results-section">
              <div className="analysis-header">
                <h3>Class Payments for {results.analysisMonth}</h3>
                <p>Showing students who have/haven't paid class fees for {results.analysisMonth}</p>
              </div>

              {/* Summary Cards */}
              <div className="summary-cards">
                <div className="summary-card total">
                  <h3>Total Students</h3>
                  <p>{results.totalCounts.total}</p>
                </div>
                <div className="summary-card paid">
                  <h3>Paid Class Fees</h3>
                  <p>{results.totalCounts.paid}</p>
                </div>
                <div className="summary-card non-paid">
                  <h3>Not Paid</h3>
                  <p>{results.totalCounts.nonPaid}</p>
                </div>
                <div className="summary-card percentage">
                  <h3>Payment Rate</h3>
                  <p>
                    {results.totalCounts.total > 0 
                      ? ((results.totalCounts.paid / results.totalCounts.total) * 100).toFixed(1) + '%' 
                      : '0%'
                    }
                  </p>
                </div>
              </div>

              {/* Batch Breakdown */}
              {/* <div className="breakdown-section">
                <h4>By Batch</h4>
                <div className="breakdown-grid">
                  {Object.entries(results.batchCounts)
                    .filter(([batch]) => batch !== 'Unknown')
                    .sort(([a], [b]) => b.localeCompare(a))
                    .map(([batch, counts]) => (
                      <div key={batch} className="breakdown-item">
                        <h5>{batch}</h5>
                        <div className="breakdown-stats">
                          <span className="paid">Paid: {counts.paid}</span>
                          <span className="non-paid">Not Paid: {counts.nonPaid}</span>
                          <span className="total">Total: {counts.total}</span>
                        </div>
                      </div>
                    ))}
                </div>
              </div> */}

              {/* Course Breakdown */}
              <div className="breakdown-section">
                <h4>By Course</h4>
                <div className="breakdown-grid">
                  {Object.entries(results.courseCounts)
                    .filter(([course]) => course !== 'Unknown')
                    .map(([course, counts]) => (
                      <div key={course} className="breakdown-item">
                        <h5>{course}</h5>
                        <div className="breakdown-stats">
                          <span className="paid">Paid: {counts.paid}</span>
                          <span className="non-paid">Not Paid: {counts.nonPaid}</span>
                          <span className="total">Total: {counts.total}</span>
                        </div>
                      </div>
                    ))}
                </div>
              </div>

              {/* Student Lists */}
              <div className="student-lists">
                <div className="student-list paid">
                  <h4>Paid Class Fees ({results.paidStudents.length})</h4>
                  <div className="student-table">
                    <div className="table-header">
                      <span>Name</span><span>Email</span><span>Course</span>
                    </div>
                    {results.paidStudents.map((student, index) => (
                      <div key={index} className="table-row">
                        <span>{student.studentName}</span><span>{student.studentEmail}</span><span>{student.course}</span>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="student-list non-paid">
                  <h4>Not Paid Class Fees ({results.nonPaidStudents.length})</h4>
                  <div className="student-table">
                    <div className="table-header">
                      <span>Name</span><span>Email</span><span>Course</span>
                    </div>
                    {results.nonPaidStudents.map((student, index) => (
                      <div key={index} className="table-row">
                        <span>{student.studentName}</span><span>{student.studentEmail}</span><span>{student.course}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}

{/******************************************************************************************************************************/}


{activeTab === 'summary' && (

  <div className="summary-container">
      <h3 className="summary-title">📊 Payment Summary</h3>

      {/* Filters */}
      <div className="summary-filters">
        {/* Year filter */}
        <select value={year} onChange={(e) => setYear(e.target.value)}>
          {Array.from({ length: 10 }, (_, i) => (
            <option key={i} value={2020 + i}>
              {2020 + i}
            </option>
          ))}
        </select>

        {/* Payment Type filter */}
        <select value={paymentType} onChange={(e) => setPaymentType(e.target.value)}>
          <option value="All">All Types</option>
          <option value="cash">Cash</option>
          <option value="deposit">Deposit</option>
          <option value="card">Card</option>
        </select>

        {/* Payment For filter */}
        <select value={paymentFor} onChange={(e) => setPaymentFor(e.target.value)}>
          <option value="All">All Payment For</option>
          <option value="exam">Exam</option>
          <option value="registration">Registration</option>
          <option value="course">Course</option>
          <option value="other">Other</option>
        </select>

        {/* Filter mode */}
        <select value={filterMode} onChange={(e) => setFilterMode(e.target.value)}>
          <option value="daily">Daily</option>
          <option value="monthly">Monthly</option>
        </select>

        {filterMode === "daily" && (
          <input
            type="date"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
          />
        )}

        {filterMode === "monthly" && (
          <select value={selectedMonth} onChange={(e) => setSelectedMonth(e.target.value)}>
            {[
              "January",
              "February",
              "March",
              "April",
              "May",
              "June",
              "July",
              "August",
              "September",
              "October",
              "November",
              "December",
            ].map((m, i) => (
              <option key={i} value={i + 1}>
                {m}
              </option>
            ))}
          </select>
        )}
      </div>

      {/* Result */}
      <div className="summary-grid">
        <div className="summary-card">
          <h4 className="summary-label">
            {filterMode.charAt(0).toUpperCase() + filterMode.slice(1)} Total
          </h4>
          <p className="summary-value">Rs. {summary.toLocaleString()}</p>
        </div>
      </div>

      {/* Charts */}
      <div className="charts-container">
        <h4>Income Trends ({year})</h4>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="month" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar dataKey="income" fill="#4f46e5" />
          </BarChart>
        </ResponsiveContainer>

        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="month" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Line type="monotone" dataKey="income" stroke="#10b981" strokeWidth={3} />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
)}

{/******************************************************************************************************************************/}






        <div className="certificate-panel">
      <ToastContainer position="top-right" autoClose={3000} />
      
      {activeTab === 'allCertificates' && (
        <div className="panel-content">
          <div className="panel-header">
            <h2>Certificate Management</h2>
            <div className="controls">
              <div className="search-filter-container">
                <div className="search-box">
                  <FontAwesomeIcon icon={faSearch} className="search-icon" />
                  <input
                    type="text"
                    placeholder="Search certificates..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
                <div className="filter-dropdown">
                  <FontAwesomeIcon icon={faFilter} className="filter-icon" />
                  <select
                    value={yearFilter}
                    onChange={(e) => setYearFilter(e.target.value)}
                  >
                    <option value="">All Years</option>
                    {yearOptions.map(year => (
                      <option key={year} value={year}>{year}</option>
                    ))}
                  </select>
                </div>
              </div>
              <span className="record-count">{filteredCertificates().length} records found</span>
            </div>
          </div>

          {loading ? (
            <div className="loading-overlay">
              <FontAwesomeIcon icon={faSpinner} spin size="2x" />
            </div>
          ) : (
            <div className="table-container">
              <table className="certificate-table">
                <thead>
                  <tr>
                    <th onClick={() => handleSort('studentName')}>
                      Student Name {sortConfig.key === 'studentName' && (
                        sortConfig.direction === 'asc' ? '↑' : '↓'
                      )}
                    </th>
                    <th onClick={() => handleSort('nicNo')}>
                      NIC No {sortConfig.key === 'nicNo' && (
                        sortConfig.direction === 'asc' ? '↑' : '↓'
                      )}
                    </th>
                    <th>Course</th>
                    <th onClick={() => handleSort('issueDate')}>
                      Issue Date {sortConfig.key === 'issueDate' && (
                        sortConfig.direction === 'asc' ? '↑' : '↓'
                      )}
                    </th>
                    <th onClick={() => handleSort('createdAt')}>
                      Created At {sortConfig.key === 'createdAt' && (
                        sortConfig.direction === 'asc' ? '↑' : '↓'
                      )}
                    </th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {sortedCertificates.length > 0 ? (
                    sortedCertificates.map(cert => (
                      <tr key={cert.id}>
                        <td>
                          {editingId === cert.id ? (
                            <input
                              type="text"
                              value={editForm.studentName}
                              onChange={(e) => setEditForm({...editForm, studentName: e.target.value})}
                            />
                          ) : (
                            cert.studentName || 'N/A'
                          )}
                        </td>
                        <td>
                          {editingId === cert.id ? (
                            <input
                              type="text"
                              value={editForm.nicNo}
                              onChange={(e) => setEditForm({...editForm, nicNo: e.target.value})}
                            />
                          ) : (
                            cert.nicNo || 'N/A'
                          )}
                        </td>
                        <td>
                          {editingId === cert.id ? (
                            <input
                              type="text"
                              value={editForm.course}
                              onChange={(e) => setEditForm({...editForm, course: e.target.value})}
                            />
                          ) : (
                            cert.course || 'N/A'
                          )}
                        </td>
                        <td>{cert.issueDate ? formatDate(cert.issueDate) : 'N/A'}</td>
                        <td>{cert.createdAt ? formatDate(cert.createdAt) : 'N/A'}</td>
                        <td className="actions">
                          {editingId === cert.id ? (
                            <>
                              <button 
                                className="save-btn"
                                onClick={handleSaveEdit}
                                title="Save"
                              >
                                Save
                              </button>
                              <button
                                className="cancel-btn"
                                onClick={() => setEditingId(null)}
                                title="Cancel"
                              >
                                Cancel
                              </button>
                            </>
                          ) : (
                            <>
                              <button 
                                className="edit-btn"
                                onClick={() => handleEdit(cert)}
                                title="Edit"
                              >
                                <FontAwesomeIcon icon={faPen} />
                              </button>
                              <button
                                className="delete-btn"
                                onClick={() => handleDelete(cert.id)}
                                disabled={deletingId === cert.id}
                                title="Delete"
                              >
                                {deletingId === cert.id ? (
                                  <FontAwesomeIcon icon={faSpinner} spin />
                                ) : (
                                  <FontAwesomeIcon icon={faTrash} />
                                )}
                              </button>
                            </>
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" className="no-data">No certificates found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      <style jsx>{`
        .certificate-panel {
          width: 100%;
          background: #fff;
          border-radius: 8px;
          box-shadow: 0 2px 10px rgba(0,0,0,0.08);
          overflow: hidden;
        }
        
        .panel-header {
          display: flex;
          flex-direction: column;
          gap: 15px;
          padding: 20px;
          border-bottom: 1px solid #eee;
        }
        
        .panel-header h2 {
          margin: 0;
          font-size: 1.5rem;
          color: #333;
        }
        
        .controls {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;
        }
        
        .search-filter-container {
          display: flex;
          gap: 15px;
          align-items: center;
        }
        
        .search-box {
          position: relative;
          display: flex;
          align-items: center;
        }
        
        .search-box input {
          padding: 8px 15px 8px 35px;
          border: 1px solid #ddd;
          border-radius: 4px;
          width: 250px;
          font-size: 0.9rem;
        }
        
        .search-icon {
          position: absolute;
          left: 10px;
          top:20px !important;
          color: blue;
        }
        
        .filter-dropdown {
          position: relative;
          display: flex;
          align-items: center;
        }
        
        .filter-dropdown select {
          padding: 8px 15px 8px 35px;
          border: 1px solid #ddd;
          border-radius: 4px;
          font-size: 0.9rem;
          appearance: none;
          background-color: white;
        }
        
        .filter-icon {
          position: absolute;
          left: 10px;
          top: 10px;
          color: blue;
        }
        
        .record-count {
          font-size: 0.9rem;
          color: #666;
        }
        
        .table-container {
          overflow-x: auto;
          padding: 0 20px 20px;
        }
        
        .certificate-table {
          width: 100%;
          border-collapse: collapse;
          min-width: 800px;
        }
        
        .certificate-table th {
          text-align: left;
          padding: 12px 15px;
          background: #88b0edff;
          color: #051c44ff;
          font-weight: 600;
          cursor: pointer;
          user-select: none;
          border-bottom: 2px solid #e2e8f0;
        }
        
        .certificate-table th:hover {
          background: #edf2f7;
        }
        
        .certificate-table td {
          padding: 12px 15px;
          border-bottom: 1px solid #e2e8f0;
          color: #4a5568;
        }
        
        .certificate-table tr:hover td {
          background: #f8fafc;
        }
        
        .certificate-table input {
          padding: 6px 10px;
          border: 1px solid #ddd;
          border-radius: 4px;
          width: 100%;
          box-sizing: border-box;
        }
        
        .actions {
          display: flex;
          gap: 8px;
        }
        
        .edit-btn, .delete-btn, .save-btn, .cancel-btn {
          background: none;
          border: none;
          cursor: pointer;
          width: 32px;
          height: 32px;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.2s;
          font-size: 0.8rem;
        }
        
        .edit-btn {
          color: #4299e1;
        }
        
        .edit-btn:hover {
          background: #ebf8ff;
        }
        
        .delete-btn {
          color: #f56565;
        }
        
        .delete-btn:hover {
          background: #fff5f5;
        }
        
        .save-btn {
          background: #48bb78;
          color: white;
          width: auto;
          padding: 0 10px;
        }
        
        .save-btn:hover {
          background: #38a169;
        }
        
        .cancel-btn {
          background: #e53e3e;
          color: white;
          width: auto;
          padding: 0 10px;
        }
        
        .cancel-btn:hover {
          background: #c53030;
        }
        
        .delete-btn:disabled {
          opacity: 0.7;
          cursor: not-allowed;
        }
        
        .no-data {
          text-align: center;
          padding: 20px;
          color: #718096;
        }
        
        .loading-overlay {
          display: flex;
          justify-content: center;
          padding: 40px;
          color: #4299e1;
        }
      `}</style>
    </div>








{activeTab === "viewAllSubmission" && (
    <div className="tab-content active">
      <h3>View All Payment Submissions</h3>

      {/* Filter Controls */}
      <div className="row mb-4">
        <div className="col-md-4">
          <label>Name</label>
          <input
            type="text"
            className="form-control"
            placeholder="Type a name..."
            value={filters.name}
            onChange={(e) =>
              setFilters({ ...filters, name: e.target.value })
            }
          />
        </div>

        <div className="col-md-4">
          <label>Status:</label>
          <select
            className="form-control"
            value={filters.status}
            onChange={(e) =>
              setFilters({ ...filters, status: e.target.value })
            }
          >
            <option value="">All Status</option>
            <option value="pending">Pending</option>
            <option value="approved">Approved</option>
            <option value="rejected">Rejected</option>
          </select>
        </div>



        <div className="col-md-4">
          <label>Fee Type:</label>
          <select
            className="form-control"
            value={filters.feeType}
            onChange={(e) =>
              setFilters({ ...filters, feeType: e.target.value })
            }
          >
            <option value="">All Fee Types</option>
            {uniqueFeeTypes.map((type) => (
              <option key={type} value={type}>
                {type}
              </option>
            ))}
          </select>
        </div>

        <div className="col-md-4">
          <label>Month:</label>
          <select
            className="form-control"
            value={filters.month}
            onChange={(e) =>
              setFilters({ ...filters, month: e.target.value })
            }
          >
            <option value="">All Months</option>
            <option value="1">January</option>
            <option value="2">February</option>
            <option value="3">March</option>
            <option value="4">April</option>
            <option value="5">May</option>
            <option value="6">June</option>
            <option value="7">July</option>
            <option value="8">August</option>
            <option value="9">September</option>
            <option value="10">October</option>
            <option value="11">November</option>
            <option value="12">December</option>
          </select>
        </div>

        <div className="col-md-4 d-flex align-items-end">
          <button
            className="btn btn-secondary"
            onClick={() =>
              setFilters({
                feeType: "",
                month: "",
                name: "",
                status: ""
              })
            }
          >
            Clear Filters
          </button>
        </div>
      </div>

      {/* Table */}
      {filteredSubmissions.length === 0 ? (
        <p>No submissions found matching your filters.</p>
      ) : (
        <div className="table-responsive">
          <table className="table table-striped table-bordered">
            <thead>
              <tr style={{ fontSize: "10px" }}>
                <th>Name</th>
                <th>Course</th>
                <th>Module Name</th>
                <th>NIC / Passport No</th>
                <th>Contact No</th>
                <th>Email</th>
                <th>Fee Type</th>
                <th>Application</th>
                <th>Payment Slip</th>
                <th>Status</th>
                <th>Actions</th>
                <th>Action 2</th>
                <th>Submitted At</th>
                <th>Exam Application</th> {/* ✅ New column */}
              </tr>
            </thead>
            <tbody>
              {filteredSubmissions.map((submission) => (
                <tr key={submission.id}>
                  <td>{submission.name}</td>
                  <td>{submission.course}</td>
                  <td>{submission.moduleName}</td>
                  <td>{submission.nicPassportNo}</td>
                  <td>{submission.contactNo}</td>
                  <td>{submission.email}</td>
                  <td>{submission.feeType}</td>
                  <td>
                    {submission.applicationFileUrl ? (
                      <a
                        href={submission.applicationFileUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="file-link"
                      >
                        View Application
                      </a>
                    ) : (
                      "N/A"
                    )}
                  </td>
                  <td>
                    {submission.paymentSlipUrl ? (
                      <a
                        href={submission.paymentSlipUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="file-link"
                      >
                        View Payment
                      </a>
                    ) : (
                      "N/A"
                    )}
                  </td>
                  <td
                    className={`status-cell ${
                      (submission.status || "").toLowerCase()
                    }`}
                  >
                    {submission.status || "Pending"}
                  </td>
                  <td className="actions-cell">
                    {(submission.status === undefined ||
                      submission.status === null ||
                      submission.status.toString().toLowerCase() ===
                        "pending") && (
                      <>
                        <button
                          onClick={() =>
                            updateSubmissionStatus(submission.id, "Approved")
                          }
                          className="btn btn-success btn-sm"
                        >
                          Approve
                        </button>
                        <button
                          onClick={() =>
                            updateSubmissionStatus(submission.id, "Rejected")
                          }
                          className="btn btn-danger btn-sm ml-2"
                        >
                          Reject
                        </button>
                      </>
                    )}
                    {submission.status &&
                      submission.status.toString().toLowerCase() !==
                        "pending" && (
                        <span className="status-badge">
                          {submission.status}
                        </span>
                      )}
                  </td>
                  <td>
                    <button
                      onClick={() => {
                        if (
                          window.confirm(
                            "Are you sure you want to delete this submission?"
                          )
                        ) {
                          deleteDoc(
                            doc(db, "formSubmissions", submission.id)
                          )
                            .then(() => {
                              setSubmissions(
                                submissions.filter(
                                  (s) => s.id !== submission.id
                                )
                              );
                            })
                            .catch((error) => {
                              console.error(
                                "Error deleting document: ",
                                error
                              );
                            });
                        }
                      }}
                      className="btn btn-danger btn-sm"
                    >
                      Delete
                    </button>
                  </td>
                  <td>
                    {submission.submittedAt?.seconds
                      ? new Date(
                          submission.submittedAt.seconds * 1000
                        ).toLocaleString()
                      : new Date(
                          submission.date || submission.submittedAt
                        ).toLocaleString()}
                  </td>

                  {/* ✅ Exam Application Button */}
           <td>
              {/* ✅ Render button only if feeType is Exam (case-insensitive) */}
              {submission.feeType?.toLowerCase() === "exam" && (
                <button
                  onClick={() => generateExamApplication(submission)}
                  className="btn-exam-download"
                >
                   📥 Exam Application
                </button>
              )}
            </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>

)}




{/*************************************************************************************************************************************/}


{activeTab === 'createPaymentSlip' && (
  <div className="create-paymentSlip-section">
  <h3 className="paymentSlip-heading">Generate Payment Slip</h3>
  
  <div className="payment-form">
    <div className="form-group">
      <label>Payment Date:</label>
      <input 
        type="date" 
        value={paymentDate}
        onChange={(e) => setPaymentDate(e.target.value)}
        required
      />
    </div>
    

<div className="form-group">
  <label>Payment Number:</label>
  <input 
    type="text" 
    value={paymentNumber}
    readOnly
    className="read-only-input"
  />
</div>

    <div className="form-group">
      <label>Student Name:</label>
      <input 
        type="text" 
        value={studentName}
        onChange={(e) => setStudentName(e.target.value)}
        required
      />
    </div>
    
    <div className="form-group">
      <label>Student Email:</label>
      <input 
        type="email" 
        value={studentEmail}
        onChange={(e) => setStudentEmail(e.target.value)}
        required
      />
    </div>

    <div className="form-group">
      <label>Payment For:</label>
      <select 
        value={paymentfor}
        onChange={(e) => setPaymentfor(e.target.value)}
      >
        <option value="class">Class Fee</option>
        <option value="exam">Exam Fee</option>
        <option value="admission">Admission Fee</option>
        <option value="registration">Registration Fee</option>
        <option value="nvq rpl">NVQ RPL Fee</option>
        <option value="nvq fee">NVQ Fee</option>
        <option value="surcharge">Surcharge</option>
        <option value="Convocation Fee">Convocation Fee</option>
        <option value="other">Other</option>
      </select>
    </div>
    
    {/* <div className="form-group">
      <label>Payment Type:</label>
      <select 
        value={paymentType}
        onChange={(e) => setPaymentType(e.target.value)}
      >
        <option value="deposit">Deposit</option>
        <option value="bank_transfer">Bank Transfer</option>
        <option value="Cheque">Cheque</option>
      </select>
    </div> */}
    
    <div className="form-group">
  <label>Payment Type:</label>
  <select 
    value={paymentType}
    onChange={(e) => setPaymentType(e.target.value)}
  >
    <option value="deposit">Deposit</option>
    <option value="bank_transfer">Bank Transfer</option>
    <option value="cheque">Cheque</option>
  </select>
</div>

{/* Conditional Cheque Number Field */}
{paymentType === "cheque" && (
  <div className="form-group">
    <label>Cheque Number:</label>
    <input
      type="text"
      value={chequeNumber}
      onChange={(e) => setChequeNumber(e.target.value)}
      placeholder="Enter cheque number"
      required
    />
  </div>
)}









<div className="form-group">
  <label>Payment For Month:</label>
  <select
    value={PaymentforMonth}
    onChange={(e) => setPaymentforMonth(e.target.value)}
  >
    <option value="">-- Select Month --</option>
    <option value="January">January</option>
    <option value="February">February</option>
    <option value="March">March</option>
    <option value="April">April</option>
    <option value="May">May</option>
    <option value="June">June</option>
    <option value="July">July</option>
    <option value="August">August</option>
    <option value="September">September</option>
    <option value="October">October</option>
    <option value="November">November</option>
    <option value="December">December</option>
    <option value="-"> - </option>
  </select>
</div>



    <div className="form-group">
      <label>Amount (Rs.):</label>
      <input 
        type="number" 
        value={amount}
        onChange={(e) => setAmount(e.target.value)}
        min="0"
        step="0.01"
        required
      />
    </div>



        <div className="form-group">
      <label>Outstanding Amount (Rs.):</label>
      <input 
        type="number" 
        value={RecieptOutstandingAmount}
        onChange={(e) => setRecieptOutstandingAmount(e.target.value)}
        min="0"
        step="0.01"
        required
      />
    </div>



        <div className="form-group">
      <label>Remark:</label>
      <input 
        type="text" 
        value={remark}
        onChange={(e) => setRemark(e.target.value)}
     
      />
    </div>



    
<button 
  className="generate-btn"
  onClick={handleCreatePaymentSlip}
  disabled={isGenerating}
>
  {isGenerating ? "Generating..." : "Generate Payment Slip"}
</button>

  </div>
</div>
)}




{/******************************************************************************************************************************/}

    {activeTab === 'viewPaymentHistory' && (
              <div className="tab-content active">
                <ViewPaymentHistory />
              </div>
            )}



{/******************************************************************************************************************************/}


 {activeTab === 'studentVerification' && (
  <div className="certificate-form-container ">
    <h2 className="text-2xl font-bold text-gray-800 mb-4">Add New Certificate</h2>

    {success && (
      <div className="mb-4 p-3 rounded bg-green-100 text-green-700 font-medium">
        Certificate added successfully!
      </div>
    )}

    {error && (
      <div className="mb-4 p-3 rounded bg-red-100 text-red-700 font-medium">
        {error}
      </div>
    )}

    <form onSubmit={handleSubmit} className="space-y-5">


      <div className="form-field flex flex-col">
        <label htmlFor="studentName" className="text-sm font-semibold text-gray-700 mb-1">Student Name</label>
        <input
          type="text"
          id="studentName"
          name="studentName"
          className="input-field border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          value={formData.studentName}
          onChange={handleChange}
          required
        />
      </div>


        <div className="form-field flex flex-col">
        <label htmlFor="nicNo" className="text-sm font-semibold text-gray-700 mb-1">NIC No</label>
        <input
          type="text"
          id="nicNo"
          name="nicNo"
          className="input-field border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          value={formData.nicNo}
          onChange={handleChange}
          required
        />
      </div>

<div className="form-field flex flex-col">
  <label htmlFor="course" className="text-sm font-semibold text-gray-700 mb-1">Course</label>
  <select
    id="course"
    name="course"
    className="input-field border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
    value={formData.course}
    onChange={handleChange}
    required
  >
    <option value="">-- Select Course --</option>
    <option value="Certificate in Optician">Certificate in Optician</option>
    <option value="Certificate in Optometry">Certificate in Optometry</option>
    <option value="Diploma in Optometry">Diploma in Optometry</option>
    <option value="Higher Diploma in Optometry">Higher Diploma in Optometry</option>
  </select>
</div>


      <div className="form-field flex flex-col">
        <label htmlFor="issueDate" className="text-sm font-semibold text-gray-700 mb-1">Issue Date</label>
        <input
          type="date"
          id="issueDate"
          name="issueDate"
          className="input-field border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          value={formData.issueDate}
          onChange={handleChange}
          required
        />
      </div>

      <button
        type="submit"
        className="submit-btn w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 rounded transition duration-200"
      >
        Add Certificate
      </button>
    </form>
  </div>
)}








{/******************************************************************************************************************************/}

        {/* {activeTab === 'manageUsers' && (
          <div className="tab-content active">
            <h3>Manage Members</h3>
            <table className="users-table">
              <thead>
                <tr>
                <th>Name</th>
                  <th>Email</th>
                  <th>Contact No</th>
                  <th>Role</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {users.map(user => (
                  <tr key={user.id}>
                    <td>{user.name}</td>
                    <td>{user.email}</td>
                    <td>{user.contactNo}</td>
                    <td>{user.role}</td>
                    <td>
                      <button className="remove-btn" onClick={() => handleRemoveUser(user.id)}>
                        Remove
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )} */}

{/******************************************************************************************************************************/}


        {activeTab === "contactMessage" && (
            <div className="tab-content active">
            <h3>View Contact Messages</h3>
            {messages.length === 0 ? (
              <p>No messages found.</p>
            ) : (
              <table className="contact-table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>Message</th>
                    <th>Address</th>
                    <th>Time</th>
                  </tr>
                </thead>
                <tbody>
                  {messages.map((msg) => (
                    <tr key={msg.id}>
                      <td>{msg.name}</td>
                      <td>{msg.email}</td>
                      <td>{msg.phone}</td>
                      <td>{msg.message}</td>
                      <td>{msg.address}</td>
                      <td>{msg.createdAt?.toDate().toLocaleString()}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        )}

{/******************************************************************************************************************************/}


      </div>
    </div>
  );
}

export default AdminPanel;
